module.exports = __webpack_public_path__ + "static/media/ordini8.b040a415.png";